import { createLabeledMessages } from '../../../messageUtils';
const help = {
    onlineChat: 'Online chat',
    shareScreen: 'Zdieľať obrazovku',
    help: 'Pomoc',
    dialogTitle: 'Začatie zdieľania obrazovky',
    dialogEndRelation: 'Ukončiť reláciu',
    dialogNeedHelp: 'Potrebujete pomôcť prostredníctvom zdieľania obrazovky?',
    dialogContact: 'Kontaktujte nás telefonicky na podpornej linke',
    dialogShareToOperator: 'Vygenerovaný PIN oznámte operátorovi'
};
const messages = Object.assign({}, help);
export default Object.assign({}, messages, createLabeledMessages(messages));
